import React from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const getAssignedToName = (shift) => {
  if (shift?.assignedToSubcontractor) return 'Subcontractor'

  const userAccount =
    shift?.assignedTo?.userAccount ||
    shift?.assignedTo?.employee?.userAccount ||
    shift?.assignedSubcontractor?.userAccount ||
    shift?.assignedSubcontractor?.subcontractor?.userAccount
  const name = [userAccount?.firstName, userAccount?.lastName]
    .filter(Boolean)
    .join(' ')
  const directName = [
    shift?.assignedTo?.firstName || shift?.assignedSubcontractor?.firstName,
    shift?.assignedTo?.lastName || shift?.assignedSubcontractor?.lastName,
  ]
    .filter(Boolean)
    .join(' ')

  return name || directName || shift?.assignedTo?.name || 'Unassigned'
}

const formatShiftTime = (value) => {
  if (!value || !moment(value).isValid()) return '--:--'

  return moment(value).format('HH:mm')
}

const AssignedShifts = ({
  form,
  setForm,
  setShiftsWithoutDuty,
  setAssignShift,
  readOnly,
}) => {
  const crewShifts = form?.crewShifts ?? []

  return (
    <Grid item xs={12}>
      {/* Display selected crew shifts */}
      {crewShifts.length === 0 ? (
        <Typography color="text.secondary" fontSize="0.9rem">
          No shifts linked to this duty yet.
        </Typography>
      ) : (
        <Stack gap={1}>
          {crewShifts.map((shift, index) => {
            return (
              <Box
                key={shift?._id ?? index}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={1}
                border="1px solid #ddd"
                borderRadius={1}
              >
                <Typography>
                  {getAssignedToName(shift)}{' '}
                  ({shift?.clinicalRole}) —{' '}
                  {formatShiftTime(shift?.start)} to{' '}
                  {formatShiftTime(shift?.end)}
                </Typography>
                {!readOnly && (
                  <Stack direction="row" gap={1} display="flex">
                    <Button
                      size="small"
                      color="anPurple"
                      onClick={() => {
                        setForm((prev) => ({
                          ...prev,
                          crewShifts: (prev.crewShifts ?? []).filter(
                            (x) => x._id !== shift._id,
                          ),
                        }))
                        setShiftsWithoutDuty((prev) => [...prev, shift])
                      }}
                    >
                      Remove
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => setAssignShift(shift)}
                    >
                      Edit
                    </Button>
                  </Stack>
                )}
              </Box>
            )
          })}
        </Stack>
      )}
    </Grid>
  )
}

export default AssignedShifts
